/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_ListInputs */

const en_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

const fr_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste`)
};

const de_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste`)
};

const it_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista`)
};

const ru_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список`)
};

const es_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista`)
};

const zh_cn2_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列表`)
};

const ja_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト`)
};

const hi_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची`)
};

const pt_pt2_markers_export_list = /** @type {(inputs: Markers_Export_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {Markers_Export_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_list = /** @type {((inputs?: Markers_Export_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_list(inputs)
	if (locale === "de") return de_markers_export_list(inputs)
	if (locale === "it") return it_markers_export_list(inputs)
	if (locale === "ru") return ru_markers_export_list(inputs)
	if (locale === "es") return es_markers_export_list(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_list(inputs)
	if (locale === "ja") return ja_markers_export_list(inputs)
	if (locale === "hi") return hi_markers_export_list(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_list(inputs)
	return en_markers_export_list(inputs)
});